// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 120000; /* Sit above the top navbar and header elements */
  animation: fadeIn 0.25s ease-out;
}

.review-modal-content {
  background: #0e1b1b; /* Matches the native adventure dark teal modal theme */
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  width: 90%;
  max-width: 550px;
  max-height: 85vh; /* Limit dialog height to fit the screen */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  color: #ffffff;
}

.review-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding-bottom: 16px;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.review-modal-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.text-gradient {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.review-close-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;
}

.review-close-btn:hover {
  color: #ffffff;
}

.review-form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}

.review-form-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  flex: 1 1;
  padding-right: 6px;
  margin-right: -6px;
}

/* Custom scrollbar for review-form-body */
.review-form-body::-webkit-scrollbar {
  width: 6px;
}
.review-form-body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
.review-form-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}
.review-form-body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

.review-error-box {
  background: rgba(220, 53, 69, 0.15);
  border: 1px solid rgba(220, 53, 69, 0.3);
  color: #ff6b6b;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
}

.review-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rating-group {
  align-items: center;
  padding: 12px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.star-rating-container {
  display: flex;
  gap: 8px;
}

.star-icon {
  font-size: 36px;
  color: rgba(255, 255, 255, 0.15);
  cursor: pointer;
  transition: transform 0.15s, color 0.15s;
}

.star-icon:hover {
  transform: scale(1.2);
}

.star-icon.active {
  color: #ffd700;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.4);
}

.rating-label {
  font-size: 13.5px;
  color: #ffd700;
  font-weight: 600;
  margin-top: 4px;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.char-count {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.char-count.insufficient {
  color: #ffb938;
}

.review-textarea {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 14px;
  color: #ffffff;
  font-size: 14.5px;
  resize: vertical;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.review-textarea:focus {
  outline: none;
  border-color: #00f2fe;
  box-shadow: 0 0 8px rgba(0, 242, 254, 0.2);
}

.photo-upload-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.photo-upload-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px dashed rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13.5px;
  transition: background-color 0.2s, border-color 0.2s;
}

.photo-upload-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #00f2fe;
}

.upload-loader {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.review-photo-preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}

.review-photo-item {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.review-photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-photo-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: #ff6b6b;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.remove-photo-btn:hover {
  background: #ff6b6b;
  color: #ffffff;
}

.review-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 20px;
  margin-top: 16px;
  flex-shrink: 0;
}

.review-btn-secondary {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.8);
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.review-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.review-btn-primary {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  border: none;
  color: #0c0f13;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.25);
}

.review-btn-primary:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

.review-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Bookings/LeaveReviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAE,iDAAiD;EAClE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB,EAAE,uDAAuD;EAC5E,6CAA6C;EAC7C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAE,0CAA0C;EAC5D,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,0CAA0C;EAC1C,yDAAyD;EACzD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".review-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 120000; /* Sit above the top navbar and header elements */\n  animation: fadeIn 0.25s ease-out;\n}\n\n.review-modal-content {\n  background: #0e1b1b; /* Matches the native adventure dark teal modal theme */\n  border: 1.5px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  width: 90%;\n  max-width: 550px;\n  max-height: 85vh; /* Limit dialog height to fit the screen */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 28px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);\n  animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  color: #ffffff;\n}\n\n.review-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  padding-bottom: 16px;\n  margin-bottom: 20px;\n  flex-shrink: 0;\n}\n\n.review-modal-header h3 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.text-gradient {\n  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.review-close-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 28px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.review-close-btn:hover {\n  color: #ffffff;\n}\n\n.review-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.review-form-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  flex: 1;\n  padding-right: 6px;\n  margin-right: -6px;\n}\n\n/* Custom scrollbar for review-form-body */\n.review-form-body::-webkit-scrollbar {\n  width: 6px;\n}\n.review-form-body::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n}\n.review-form-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 3px;\n}\n.review-form-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.review-error-box {\n  background: rgba(220, 53, 69, 0.15);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  color: #ff6b6b;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.review-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.rating-group {\n  align-items: center;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n}\n\n.star-rating-container {\n  display: flex;\n  gap: 8px;\n}\n\n.star-icon {\n  font-size: 36px;\n  color: rgba(255, 255, 255, 0.15);\n  cursor: pointer;\n  transition: transform 0.15s, color 0.15s;\n}\n\n.star-icon:hover {\n  transform: scale(1.2);\n}\n\n.star-icon.active {\n  color: #ffd700;\n  text-shadow: 0 0 10px rgba(255, 215, 0, 0.4);\n}\n\n.rating-label {\n  font-size: 13.5px;\n  color: #ffd700;\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n.label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.char-count {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.char-count.insufficient {\n  color: #ffb938;\n}\n\n.review-textarea {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 14px;\n  color: #ffffff;\n  font-size: 14.5px;\n  resize: vertical;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.review-textarea:focus {\n  outline: none;\n  border-color: #00f2fe;\n  box-shadow: 0 0 8px rgba(0, 242, 254, 0.2);\n}\n\n.photo-upload-container {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.photo-upload-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px dashed rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 10px 16px;\n  cursor: pointer;\n  font-size: 13.5px;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.photo-upload-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #00f2fe;\n}\n\n.upload-loader {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.review-photo-preview-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.review-photo-item {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.review-photo-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.remove-photo-btn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  color: #ff6b6b;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.remove-photo-btn:hover {\n  background: #ff6b6b;\n  color: #ffffff;\n}\n\n.review-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  padding-top: 20px;\n  margin-top: 16px;\n  flex-shrink: 0;\n}\n\n.review-btn-secondary {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.8);\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.review-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n.review-btn-primary {\n  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n  border: none;\n  color: #0c0f13;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.2s;\n  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.25);\n}\n\n.review-btn-primary:hover {\n  opacity: 0.95;\n  transform: translateY(-1px);\n}\n\n.review-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
